<template>
  <div class="tarifs" data-model-id="3:3728">
    <NavSubsection />
    <HeroSubsection />
    <PricingCardsSubsection />
    <DetailsSubsection />
    <FAQSubsection />
    <CTASubsection />
    <FooterSubsection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavSubsection from "./Tarifs/sections/NavSubsection.vue";
import HeroSubsection from "./Tarifs/sections/HeroSubsection.vue";
import PricingCardsSubsection from "./Tarifs/sections/PricingCardsSubsection.vue";
import DetailsSubsection from "./Tarifs/sections/DetailsSubsection.vue";
import FAQSubsection from "./Tarifs/sections/FAQSubsection.vue";
import CTASubsection from "./Tarifs/sections/CTASubsection.vue";
import FooterSubsection from "./Tarifs/sections/FooterSubsection.vue";

export default defineComponent({
  name: "Tarifs",
  components: {
    NavSubsection,
    HeroSubsection,
    PricingCardsSubsection,
    DetailsSubsection,
    FAQSubsection,
    CTASubsection,
    FooterSubsection,
  },
});
</script>

<style>
.tarifs {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .tarifs :is(
      .hero-subsection,
      .pricing-cards-subsection,
      .details-subsection,
      .faq-subsection,
      .cta-subsection
    ) {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .tarifs :is(.details-content, .faq-list, .cta-content) {
    min-width: 0 !important;
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .tarifs :is(
      .hero-subsection,
      .pricing-cards-subsection,
      .details-subsection,
      .faq-subsection,
      .cta-subsection
    ) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
</style>
